import {PATHS} from 'Routes';
import {useTranslation} from 'react-i18next';
import {useNavigate, useParams} from 'react-router-dom';
import {usePath} from 'hooks';
import {useFetchGuidebook} from 'hooks/guidebooks/useFetchGuidebook';
import {useFetchGuidebookGroups} from 'hooks/guidebooks/useFetchGuidebookGroups';
import {useSummary} from 'context/summary';
import Page from 'components/Page';
import UnavailableFeature from 'components/UnavailableFeature';
import {GuidebookContent} from './components/GuidebookContent';
import {StyledGuidebookData, UnavailableIcon} from './styled';

function GuidebookView() {
  const {t, i18n} = useTranslation();
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {id: groupId} = useParams();
  const {reservationId} = useSummary();
  const {data: guidebooksByGroup} = useFetchGuidebookGroups({groupId});
  const language = i18n.language;

  const selectedGuidebook =
    guidebooksByGroup?.find(group => group.locale === language) ??
    guidebooksByGroup?.find(group => group.is_default);

  const {data, error, isInitialLoading} = useFetchGuidebook({
    guidebookId: selectedGuidebook?.id,
    reservationId,
  });

  const goToHome = () => {
    navigate(getFullPath(PATHS.home));
  };

  return (
    <Page
      isSubHeaderVisible
      title={data?.title}
      isLoading={isInitialLoading || !selectedGuidebook}
      navBarTitle={data?.title}
      subtitle={undefined}
      hideSubPanelBackButton
      onBackButtonClick={goToHome}
      className="guidebook-view"
    >
      <UnavailableFeature
        title={t('guidebook_not_available_yet')}
        subtitle={t('this_guidebook_will_be_displayed_when')}
        reasons={error?.detail}
        icon={<UnavailableIcon name="unavailable-books" size={200} />}
      />
      {!error && !isInitialLoading && (
        <StyledGuidebookData>
          <GuidebookContent content={selectedGuidebook?.data} />
        </StyledGuidebookData>
      )}
    </Page>
  );
}

export {GuidebookView};
